import { ref, onBeforeUnmount } from 'vue';

// Safari may fire compositionend before the confirming Enter keydown.
// Keep the manual flag true until the next macrotask.
export const useImeCompositionGuard = () => {
    const isComposingIME = ref(false);
    let resetTimer: ReturnType<typeof setTimeout> | null = null;

    const onCompositionStart = (): void => {
        isComposingIME.value = true;
    };

    const onCompositionEnd = (): void => {
        resetTimer = setTimeout(() => {
            isComposingIME.value = false;
            resetTimer = null;
        }, 0);
    };

    const isComposing = (event: KeyboardEvent): boolean =>
        event.isComposing || isComposingIME.value;

    onBeforeUnmount(() => {
        if (resetTimer !== null) {
            clearTimeout(resetTimer);
        }
    });

    return { onCompositionStart, onCompositionEnd, isComposing };
};
